import { render, staticRenderFns } from "./files.vue?vue&type=template&id=f2aff1a0&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=f2aff1a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aff1a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2aff1a0')) {
      api.createRecord('f2aff1a0', component.options)
    } else {
      api.reload('f2aff1a0', component.options)
    }
    module.hot.accept("./files.vue?vue&type=template&id=f2aff1a0&scoped=true", function () {
      api.rerender('f2aff1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programList/components/files.vue"
export default component.exports